import script from "./idFindComplete.vue?vue&type=script&setup=true&name=idFindDomplete&lang=js"
export * from "./idFindComplete.vue?vue&type=script&setup=true&name=idFindDomplete&lang=js"

const __exports__ = script;

export default __exports__